import React from 'react';
import usePayments from '../../../hooks/api/usePayments';
import { usePromptButton } from '../PromptButton';
import RegistrationCodePromptContents from './RegistrationCodePromptContents';
import { getIntl } from '../../../utils/intl';
import { Platform } from 'react-native';

const intl = getIntl('useRegistrationCodeActionButton', {
    invitationOrCouponCodeButtonText: 'Invitation or Coupon Code?',
    invitationOrCouponCodeHeader: 'Invitation or Coupon Code',
});

export type UseRegistrationCodeActionButtonOwnReturnValue = {
    shouldShow?: boolean;
    Prompt: React.ReactNode;
    onPress: () => void;
};

export const useRegistrationCodeActionButton = (): UseRegistrationCodeActionButtonOwnReturnValue => {
    const { isLoadingRegistrationCodeStatus, myRegistrationCodeStatus } = usePayments({});
    const { onPress, Prompt } = usePromptButton({
        renderPromptContents: (onClose) => <RegistrationCodePromptContents onClosePrompt={onClose} />,
        promptTitle: intl('invitationOrCouponCodeHeader'),
    });

    if (
        isLoadingRegistrationCodeStatus ||
        !myRegistrationCodeStatus ||
        myRegistrationCodeStatus.status.type !== 'no-registration-code' ||
        Platform.OS === 'ios'
    ) {
        return { shouldShow: false, Prompt, onPress };
    } else {
        return { shouldShow: true, Prompt, onPress };
    }
};
